/* =========================================================
   INKSOFT DESIGN IDEAS MODULE
========================================================= */

window.InksoftPOC = window.InksoftPOC || {};

window.InksoftPOC.designIdeas = (function () {
  const core = window.InksoftPOC.core;

  const state = {
    categories: [],
    cache: {},
    currentCategoryId: '',
    currentCategoryName: ''
  };

  function asArray(value) {
    return Array.isArray(value) ? value : [];
  }

  function asString(value) {
    return value == null ? '' : String(value).trim();
  }

  function normalizeInksoftUrl(url) {
    let value = asString(url);
    if (!value) return '';

    value = value.replace(/\/Unisource_Apparel\/Unisource_Apparel\//g, '/Unisource_Apparel/');

    if (/^https?:\/\//i.test(value)) return value;
    if (value.indexOf('/Unisource_Apparel/') === 0) return 'https://shop.unisourceapparel.com' + value;
    if (value.indexOf('/images/') === 0) return 'https://shop.unisourceapparel.com/Unisource_Apparel' + value;
    if (value.indexOf('/JITImage/') === 0) return 'https://shop.unisourceapparel.com/Unisource_Apparel' + value;

    return value;
  }

  function shuffle(items) {
    const copy = Array.isArray(items) ? items.slice() : [];
    for (let i = copy.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      const temp = copy[i];
      copy[i] = copy[j];
      copy[j] = temp;
    }
    return copy;
  }

  function getVisibleCount() {
    if (window.innerWidth <= 768) return 1;
    if (window.innerWidth <= 980) return 3;
    if (window.innerWidth <= 1400) return 4;
    return 6;
  }

  function isSvgUrl(url) {
    return /\.svg(?:\?|#|$)/i.test(asString(url));
  }

  function isPngUrl(url) {
    return /\.png(?:\?|#|$)/i.test(asString(url));
  }

  function getDesignId(design) {
    if (!design || typeof design !== 'object') return '';

    const candidates = [
      design.designId,
      design.DesignId,
      design.id,
      design.ID,
      design.Id
    ];

    for (let i = 0; i < candidates.length; i += 1) {
      const value = asString(candidates[i]);
      if (value) return value;
    }

    return '';
  }

  function collectCandidateUrlFields(obj, prefix, results, visited) {
    if (!obj || typeof obj !== 'object') return;
    if (visited.has(obj)) return;
    visited.add(obj);

    if (Array.isArray(obj)) {
      obj.forEach(function (item, index) {
        collectCandidateUrlFields(item, `${prefix}[${index}]`, results, visited);
      });
      return;
    }

    Object.keys(obj).forEach(function (key) {
      const value = obj[key];
      const path = prefix ? `${prefix}.${key}` : key;
      const keyLower = String(key).toLowerCase();

      if (
        typeof value === 'string' &&
        value.trim() &&
        (
          keyLower.includes('url') ||
          keyLower.includes('image') ||
          keyLower.includes('file') ||
          keyLower.includes('path') ||
          keyLower.includes('preview') ||
          keyLower.includes('artwork') ||
          keyLower.includes('svg') ||
          keyLower.includes('source')
        )
      ) {
        results.push({
          field: path,
          value: normalizeInksoftUrl(value)
        });
      }

      if (value && typeof value === 'object') {
        collectCandidateUrlFields(value, path, results, visited);
      }
    });
  }

  function getDebugAssetCandidates(design) {
    const results = [];
    collectCandidateUrlFields(design, '', results, new WeakSet());

    const deduped = [];
    const seen = new Set();

    results.forEach(function (item) {
      const key = `${item.field}::${item.value}`;
      if (!seen.has(key)) {
        seen.add(key);
        deduped.push(item);
      }
    });

    return deduped;
  }

  function pickBestDesignImage(design) {
    if (!design || typeof design !== 'object') return '';

    const candidates = [];
    const canvases = []
      .concat(asArray(design.canvases))
      .concat(asArray(design.Canvases));

    canvases.forEach(function (canvas) {
      const canvasImage = normalizeInksoftUrl(asString(
        canvas && (
          canvas.imageUrl ||
          canvas.ImageUrl ||
          canvas.previewUrl ||
          canvas.PreviewUrl
        )
      ));

      if (canvasImage) candidates.push(canvasImage);

      const svg = normalizeInksoftUrl(asString(
        canvas && (
          canvas.svgUrl ||
          canvas.SvgUrl ||
          canvas.svgURL ||
          canvas.SvgURL
        )
      ));

      if (svg) candidates.push(svg);

      const thumbnail = normalizeInksoftUrl(asString(
        canvas && (
          canvas.thumbnailUrl ||
          canvas.ThumbnailUrl ||
          canvas.thumbnailURL ||
          canvas.ThumbnailURL
        )
      ));

      if (thumbnail) candidates.push(thumbnail);
    });

    [
      design.imageUrl,
      design.ImageUrl,
      design.previewImageUrl,
      design.PreviewImageUrl,
      design.previewUrl,
      design.PreviewUrl,
      design.thumbnailUrl,
      design.ThumbnailUrl,
      design.artworkUrl,
      design.ArtworkUrl,
      design.fileUrl,
      design.FileUrl,
      design.coverArtUrl,
      design.CoverArtUrl
    ].forEach(function (url) {
      const normalized = normalizeInksoftUrl(asString(url));
      if (normalized) candidates.push(normalized);
    });

    const assetCandidates = getDebugAssetCandidates(design);
    assetCandidates.forEach(function (item) {
      if (item && item.value) candidates.push(item.value);
    });

    const deduped = [];
    const seen = new Set();

    candidates.forEach(function (url) {
      if (!url || seen.has(url)) return;
      seen.add(url);
      deduped.push(url);
    });

    for (let i = 0; i < deduped.length; i += 1) {
      if (/\.480\.png(?:\?|#|$)/i.test(deduped[i])) {
        return deduped[i];
      }
    }

    for (let i = 0; i < deduped.length; i += 1) {
      if (/\.png(?:\?|#|$)/i.test(deduped[i]) && deduped[i].indexOf('/JITImage/') === -1) {
        return deduped[i];
      }
    }

    for (let i = 0; i < deduped.length; i += 1) {
      if (/\/JITImage\//i.test(deduped[i])) {
        return deduped[i];
      }
    }

    for (let i = 0; i < deduped.length; i += 1) {
      if (!isSvgUrl(deduped[i])) {
        return deduped[i];
      }
    }

    return deduped[0] || '';
  }

  function pickDesignCardImage(design) {
    return normalizeInksoftUrl(asString(
      design && (
        design.thumbnailUrl || design.ThumbnailUrl ||
        design.coverArtUrl || design.CoverArtUrl ||
        design.imageUrl || design.ImageUrl ||
        design.previewUrl || design.PreviewUrl ||
        design.artworkUrl || design.ArtworkUrl
      )
    ));
  }

  async function fetchCategories() {
    const payload = await core.fetchJSON('https://shopify-inksoft-poc-node.azurewebsites.net/api/poc/design-categories');
    if (payload && Array.isArray(payload.data)) return payload.data;
    if (payload && Array.isArray(payload.categories)) return payload.categories;
    if (Array.isArray(payload)) return payload;
    return [];
  }

  async function fetchDesigns(categoryId) {
    const payload = await core.fetchJSON(`https://shopify-inksoft-poc-node.azurewebsites.net/api/poc/designs?categoryId=${encodeURIComponent(categoryId)}`);
    if (payload && Array.isArray(payload.data)) return payload.data;
    if (payload && Array.isArray(payload.designs)) return payload.designs;
    if (Array.isArray(payload)) return payload;
    return [];
  }

  function buildCardHtml(design) {
    const image = pickDesignCardImage(design);
    const title = asString(design && (design.name || design.Name || 'Untitled Design'));
    const subtitle = asString(
      design && (
        design.description || design.Description ||
        design.designNumber || design.DesignNumber || 'Ready for preview'
      )
    );
    const designId = getDesignId(design);

    return `
      <div class="inksoft-design-card">
        <div class="inksoft-design-card__image-wrap">
          ${
            image
              ? `<img class="inksoft-design-card__image" src="${core.escapeHtml(image)}" alt="${core.escapeHtml(title)}" width="320" height="320">`
              : `<div class="inksoft-design-ideas-empty">No image</div>`
          }
        </div>

        <div class="inksoft-design-card__body">
          <div class="inksoft-design-card__tag">Design Idea</div>
          <h3 class="inksoft-design-card__title">${core.escapeHtml(title)}</h3>
          <div class="inksoft-design-card__meta">${core.escapeHtml(subtitle || 'Ready for preview')}</div>

          <div class="inksoft-design-card__actions">
            <button
              type="button"
              class="inksoft-design-card__button"
              data-design-id="${core.escapeHtml(designId)}"
            >
              Use This Design
            </button>
          </div>
        </div>
      </div>
    `;
  }

  function attachTrackBehavior(sectionEl) {
    const trackEl = sectionEl.querySelector('#inksoft-design-track');
    const inner = trackEl ? trackEl.querySelector('.inksoft-design-track-inner') : null;
    if (!trackEl || !inner) return;

    const totalItems = Number(trackEl.getAttribute('data-total-items') || 0);
    let page = 0;

    function update() {
      const visibleCount = getVisibleCount();
      const maxPage = Math.max(0, Math.ceil(totalItems / visibleCount) - 1);
      if (page > maxPage) page = maxPage;
      inner.style.transform = `translateX(-${page * 100}%)`;
    }

    Array.prototype.forEach.call(sectionEl.querySelectorAll('.inksoft-design-scroll'), function (button) {
      button.addEventListener('click', function () {
        const visibleCount = getVisibleCount();
        const maxPage = Math.max(0, Math.ceil(totalItems / visibleCount) - 1);
        const isLeft = button.classList.contains('inksoft-design-scroll--left');

        if (isLeft) {
          page = Math.max(0, page - 1);
        } else {
          page = Math.min(maxPage, page + 1);
        }

        update();
      });
    });

    window.addEventListener('resize', update);
    update();
  }

  function getSelectedCategoryName(sectionEl) {
    const select = sectionEl.querySelector('#inksoft-design-category-select');
    if (!select) return '';
    const option = select.options[select.selectedIndex];
    return option ? asString(option.text) : '';
  }

  function getDebugSummary(design) {
    const assetCandidates = getDebugAssetCandidates(design);

    const svgCandidates = assetCandidates.filter(function (item) {
      return /\.svg(?:\?|#|$)/i.test(item.value) || item.field.toLowerCase().includes('svg');
    });

    const likelyTransparentPngCandidates = assetCandidates.filter(function (item) {
      return /\.png(?:\?|#|$)/i.test(item.value);
    });

    const vectorHintFields = [];
    const vectorKeysToCheck = [
      'mimeType', 'MimeType', 'fileType', 'FileType', 'extension', 'Extension',
      'format', 'Format', 'isVector', 'IsVector', 'vector', 'Vector',
      'sourceExtension', 'SourceExtension'
    ];

    vectorKeysToCheck.forEach(function (key) {
      if (design && Object.prototype.hasOwnProperty.call(design, key)) {
        vectorHintFields.push({
          field: key,
          value: design[key]
        });
      }
    });

    return {
      id: getDesignId(design),
      rawId: {
        designId: asString(design && design.designId),
        DesignId: asString(design && design.DesignId),
        id: asString(design && design.id),
        ID: asString(design && design.ID),
        Id: asString(design && design.Id)
      },
      name: asString(design && (design.name || design.Name || '')),
      thumbnailUrl: normalizeInksoftUrl(asString(design && (design.thumbnailUrl || design.ThumbnailUrl || ''))),
      imageUrl: normalizeInksoftUrl(asString(design && (design.imageUrl || design.ImageUrl || ''))),
      previewUrl: normalizeInksoftUrl(asString(design && (design.previewUrl || design.PreviewUrl || ''))),
      artworkUrl: normalizeInksoftUrl(asString(design && (design.artworkUrl || design.ArtworkUrl || ''))),
      coverArtUrl: normalizeInksoftUrl(asString(design && (design.coverArtUrl || design.CoverArtUrl || ''))),
      pickedBestImage: pickBestDesignImage(design),
      svgCandidates: svgCandidates,
      pngCandidates: likelyTransparentPngCandidates.slice(0, 20),
      vectorHintFields: vectorHintFields,
      assetCandidates: assetCandidates.slice(0, 50)
    };
  }

  function logSelectedDesignDebug(selected) {
    try {
      const summary = getDebugSummary(selected);

      console.group('[Inksoft Design Debug] Selected design');
      console.log('Selected design object:', selected);
      console.log('Design debug summary:', summary);

      if (summary.svgCandidates.length) {
        console.log('Possible SVG candidates found:', summary.svgCandidates);
      } else {
        console.log('No obvious SVG candidates found in the selected design object.');
      }

      if (summary.vectorHintFields.length) {
        console.log('Possible vector/source hint fields:', summary.vectorHintFields);
      } else {
        console.log('No explicit vector/source hint fields found.');
      }

      console.groupEnd();
    } catch (error) {
      console.warn('[Inksoft Design Debug] Failed to inspect selected design object.', error);
    }
  }

  async function loadDesignsIntoSection(sectionEl, categoryId, reshuffleOnly, onApplyDesign) {
    const track = sectionEl.querySelector('#inksoft-design-track');
    const refreshBtn = sectionEl.querySelector('#inksoft-design-refresh');
    if (!track) return;

    if (!categoryId) {
      track.innerHTML = '<div class="inksoft-design-ideas-empty">No design category selected.</div>';
      return;
    }

    state.currentCategoryId = categoryId;
    state.currentCategoryName = getSelectedCategoryName(sectionEl);

    if (refreshBtn) refreshBtn.disabled = true;
    if (!reshuffleOnly) {
      track.innerHTML = '<div class="inksoft-design-ideas-empty">Loading designs...</div>';
    }

    try {
      if (!state.cache[categoryId]) {
        state.cache[categoryId] = await fetchDesigns(categoryId);
      }

      const randomized = shuffle(state.cache[categoryId]).slice(0, 24);

      if (!randomized.length) {
        track.innerHTML = '<div class="inksoft-design-ideas-empty">No designs available in this category.</div>';
        return;
      }

      track.innerHTML = `
        <div class="inksoft-design-track-inner">
          ${randomized.map(buildCardHtml).join('')}
        </div>
      `;
      track.setAttribute('data-total-items', String(randomized.length));

      Array.prototype.forEach.call(track.querySelectorAll('[data-design-id]'), function (button) {
        button.addEventListener('click', function () {
          const designId = button.getAttribute('data-design-id') || '';
          const selected = randomized.filter(function (item) {
            return getDesignId(item) === designId;
          })[0] || null;

          if (selected) {
            logSelectedDesignDebug(selected);
          }

          if (selected && typeof onApplyDesign === 'function') {
            const resolvedDesignId = getDesignId(selected);

            const shareCandidates = [
              selected.shareUrl,
              selected.ShareUrl,
              selected.shareLink,
              selected.ShareLink,
              selected.url,
              selected.Url,
              selected.href,
              selected.Href
            ];

            let resolvedShareUrl = '';

            for (let i = 0; i < shareCandidates.length; i++) {
              const val = normalizeInksoftUrl(shareCandidates[i]);

              /*
                Keep the same behavior for /share/... URLs, but also accept
                prepared /design-studio/design URLs. Some InkSoft design records
                include a ready-to-open Designer URL there, and that can load
                much faster than rebuilding a raw /share/{product}/{style}/{design}
                URL from the product page.
              */
              if (
                val &&
                (
                  val.indexOf('/design-studio/share/') !== -1 ||
                  val.indexOf('/design-studio/design') !== -1
                )
              ) {
                resolvedShareUrl = val;
                break;
              }
            }

            console.log('[DesignIdeas] Selected design launch/share URL:', resolvedShareUrl);

            onApplyDesign({
              id: resolvedDesignId,
              designId: resolvedDesignId,
              DesignId: resolvedDesignId,
              name: asString(selected.name || selected.Name || 'Design'),

              imageUrl: pickBestDesignImage(selected),
              previewImageUrl: pickDesignCardImage(selected),

              launchUrl: resolvedShareUrl,
              selectedShareUrl: resolvedShareUrl,
              shareUrl: resolvedShareUrl,

              categoryId: state.currentCategoryId,
              categoryName: state.currentCategoryName,

              debugSelectedDesign: selected,
              rawDesign: selected
            });
          }
        });
      });

      attachTrackBehavior(sectionEl);
    } catch (err) {
      track.innerHTML = '<div class="inksoft-design-ideas-empty">Unable to load design ideas right now.</div>';
    } finally {
      if (refreshBtn) refreshBtn.disabled = false;
    }
  }

  async function render(containerEl, onApplyDesign) {
    if (!containerEl) return;

    containerEl.innerHTML = `
      <section class="inksoft-design-ideas-section">
        <div class="inksoft-design-ideas-head">
          <h2 class="inksoft-design-ideas-title">Design Ideas</h2>
          <p class="inksoft-design-ideas-subtitle">Browse available design ideas and apply them to the product preview.</p>
        </div>

        <div class="inksoft-design-ideas-toolbar">
          <label class="inksoft-design-ideas-label" for="inksoft-design-category-select">Category</label>
          <select id="inksoft-design-category-select" class="inksoft-design-ideas-select">
            <option value="">Loading categories...</option>
          </select>
          <button type="button" id="inksoft-design-refresh" class="inksoft-design-ideas-refresh">Refresh 24 Designs</button>
        </div>

        <div class="inksoft-design-carousel">
          <button
            type="button"
            class="inksoft-design-scroll inksoft-design-scroll--left"
            aria-label="Scroll design ideas left"
          >‹</button>

          <div id="inksoft-design-track" class="inksoft-design-track"></div>

          <button
            type="button"
            class="inksoft-design-scroll inksoft-design-scroll--right"
            aria-label="Scroll design ideas right"
          >›</button>
        </div>
      </section>
    `;

    const select = containerEl.querySelector('#inksoft-design-category-select');
    const refreshBtn = containerEl.querySelector('#inksoft-design-refresh');
    const track = containerEl.querySelector('#inksoft-design-track');

    if (!select || !track) return;

    track.innerHTML = '<div class="inksoft-design-ideas-empty">Loading designs...</div>';

    try {
      state.categories = await fetchCategories();

      if (!state.categories.length) {
        select.innerHTML = '<option value="">No categories found</option>';
        track.innerHTML = '<div class="inksoft-design-ideas-empty">No design categories available.</div>';
        return;
      }

      select.innerHTML = state.categories.map(function (category) {
        const id = asString(
          category && (
            category.id || category.ID || category.Id ||
            category.designCategoryId || category.DesignCategoryId || ''
          )
        );

        const name = asString(
          category && (
            category.name || category.Name || category.title || category.Title || 'Category'
          )
        );

        return `<option value="${core.escapeHtml(id)}">${core.escapeHtml(name)}</option>`;
      }).join('');

      state.currentCategoryId = select.value || '';
      state.currentCategoryName = getSelectedCategoryName(containerEl);

      await loadDesignsIntoSection(containerEl, state.currentCategoryId, false, onApplyDesign);

      select.addEventListener('change', function () {
        loadDesignsIntoSection(containerEl, this.value, false, onApplyDesign);
      });

      if (refreshBtn) {
        refreshBtn.addEventListener('click', function () {
          loadDesignsIntoSection(containerEl, state.currentCategoryId || select.value || '', true, onApplyDesign);
        });
      }
    } catch (err) {
      select.innerHTML = '<option value="">Design catalog unavailable</option>';
      track.innerHTML = '<div class="inksoft-design-ideas-empty">Design ideas are unavailable right now.</div>';
    }
  }

  return {
    render
  };
})();